import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import moment from 'moment';

const SalesStatus = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const TabTitle = [
    { name: 'Tab1', content: 'Tab menu ONE' },
    { name: 'Tab2', content: 'Tab menu TWO' },
    { name: 'Tab3', content: 'Tab menu THREE' },
  ];
  const selectTabHandler = (index: number) => {
    setCurrentTab(index);
  };

  return (
    <Style>
      <div className="contentContainer">
        <div className="tabWrap">
          {TabTitle.map((data, index: number) => (
            <div
              className={index === currentTab ? 'tab focused' : 'tab'}
              onClick={() => selectTabHandler(index)}>
              {data.name}
            </div>
          ))}
        </div>
        <p>{TabTitle[currentTab].content}</p>
      </div>
    </Style>
  );
};

export default SalesStatus;

const Style = styled.div``;
